import styled from 'styled-components';

/**
 * Displays an ellipsis shape with an hourglass icon centered on top of it.
 */
export const EllipsisWithHourglassIcon: React.FC = () => {
  return (
    <GridContainer>
      <GridItem>
        {/* Ellipsis SVG */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="110"
          height="120"
          viewBox="0 0 110 120"
          fill="none"
        >
          <ellipse
            cx="54.8228"
            cy="59.9754"
            rx="40"
            ry="70.7126"
            transform="rotate(40 54.8228 59.9754)"
            fill="#F7F3F3"
          />
        </svg>
      </GridItem>

      <GridItem>
        {/* Hourglass icon on top of the ellipsis */}
        <img
          height={28}
          width={28}
          alt="Hour glass"
          title="Hour glass"
          src="https://assets.storebrand.no/pretzel/icons/hourglass.svg"
        />
      </GridItem>
    </GridContainer>
  );
};

const GridContainer = styled.div`
  display: grid;
  place-items: center;
`;

const GridItem = styled.div`
  grid-column: 1;
  grid-row: 1;
`;
